'use client'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { isSessionMismatched } from '@/helper/reconcileSession'
import { forceCleanLogout } from '@/utils/sessionCleanup'
import useCustomToast from '@/hooks/useCustomToast'
import { PROTECTED_ROUTES } from '@/utils/constants'

// Catches a stale session (cookie gone, localStorage uidx still present) on protected pages that wouldn't otherwise trigger a 401.
export const useSessionReconciliation = () => {
  const pathname = usePathname()
  const showToast = useCustomToast()
  const isProtectedRoute = PROTECTED_ROUTES.some((route) =>
    pathname?.startsWith(route)
  )

  useEffect(() => {
    if (!isProtectedRoute) return
    let cancelled = false
    const checkSession = async () => {
      const mismatched = await isSessionMismatched()
      if (mismatched && !cancelled) {
        showToast('danger', 'Your session has expired. Please log in again.')
        await forceCleanLogout()
      }
    }
    checkSession()
    return () => {
      cancelled = true
    }
  }, [pathname, isProtectedRoute])
}
